let idCounter = 0;
export function generateUniqueId(prefix = 'uid') {
    idCounter += 1;
    return `${prefix}-${idCounter}`;
}
//# sourceMappingURL=idUtils.js.map